import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  notFound: {
    id: 'studio.I447TL',
    defaultMessage: 'The app you are looking for could not be found.',
  },
  uncaughtError: {
    id: 'studio.V4945s',
    defaultMessage: 'There was a problem loading the app. Please try again.',
  },
  permissionError: {
    id: 'studio.PPSPn3',
    defaultMessage: 'You do not have permission to view this app.',
  },
  assets: {
    id: 'studio.d1uESJ',
    defaultMessage: 'Assets',
  },
  details: {
    id: 'studio.Lv0zJu',
    defaultMessage: 'Details',
  },
  editor: {
    id: 'studio.fWKwFM',
    defaultMessage: 'Editor',
  },
  definition: {
    id: 'studio.t1Iyem',
    defaultMessage: 'App definition',
  },
  resources: {
    id: 'studio.c/KktL',
    defaultMessage: 'Resources',
  },
  settings: {
    id: 'studio.D3idYv',
    defaultMessage: 'Settings',
  },
  variables: {
    id: 'studio.tr0YPg',
    defaultMessage: 'Variables',
  },
  secrets: {
    id: 'studio.WKtGHy',
    defaultMessage: 'Secrets',
  },
  quotas: {
    id: 'studio.4l+0pK',
    defaultMessage: 'Quotas',
  },
  snapshots: {
    id: 'studio.4y3rEL',
    defaultMessage: 'Snapshots',
  },
  notifications: {
    id: 'studio.NAidKb',
    defaultMessage: 'Notifications',
  },
  users: {
    id: 'studio.c/TTro',
    defaultMessage: 'App members',
  },
  groups: {
    id: 'studio.hzmswI',
    defaultMessage: 'Groups',
  },
  translations: {
    id: 'studio.aFyu8N',
    defaultMessage: 'Translations',
  },
  locked: {
    id: 'studio.KxUbuJ',
    defaultMessage:
      'This app is currently locked. No changes can be made without first unlocking the app in the settings.',
  },
  logs: {
    id: 'studio.QXAhtx',
    defaultMessage: 'Container logs',
  },
});
